import './CategorySelector.css';
import TypeaheadField from './TypeaheadField';
import { CATEGORY_OPTIONS } from './discoveryOptions';

const categoryOptions = CATEGORY_OPTIONS.map((option) => ({
  ...option,
  key: option.slug ?? option.name.toLowerCase(),
}));

function CategorySelector({ value, onChange, disabled = false }) {
  const getLabel = (option) => option?.name ?? option?.label ?? '';
  const getKey = (option) =>
    option?.key ?? option?.id ?? option?.slug ?? option?.name ?? option?.label ?? '';

  return (
    <div className="CategorySelector">
      <TypeaheadField
        label="Category"
        placeholder="Search categories"
        selectedOption={value}
        onSelect={onChange}
        options={categoryOptions}
        getOptionLabel={getLabel}
        getOptionKey={getKey}
        disabled={disabled}
        description="Discover clips by game or topic"
        allowFreeInput
      />
    </div>
  );
}

export default CategorySelector;
